import PlanInfo from "./PlanInfo";
import Utilities from "./Utilities";
import PaymentMethods from "./PaymentMethods";
import BillingDocuments from "./BillingDocuments";
import CreditCardForm from "../../../../../components/forms/CreditCardForm";

const plansBillingComponents = {
  PlanInfo,
  Utilities,
  PaymentMethods,
  BillingDocuments,
  CreditCardForm
}

export default plansBillingComponents